import React from "react";
import styled from "styled-components";

import colors from "../colors";

const { darkBlue, white, black } = colors;

const STANDARD_BUBBLE_SIZE = 36;
const SMALL_BUBBLE_SIZE = 22;

const Bubble = styled.div`
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 50%;
  text-align: center;
  line-height: ${({ size }) => size}px;
  white-space: nowrap;
  border: 1px solid ${({ borderColor }) => borderColor};
  color: ${({ textColor }) => textColor};
  margin: 0 auto;
`;

function BubbleIcon(props = {}) {
  const {
    backgroundColor = darkBlue,
    textColor = white,
    borderColor = darkBlue,
    size = STANDARD_BUBBLE_SIZE,
    bullet = ""
  } = props;

  return (
    <Bubble
      size={size}
      borderColor={borderColor}
      backgroundColor={backgroundColor}
      textColor={textColor}
    >
      {bullet}
    </Bubble>
  );
}

const SmallBubbleIcon = props => (
  <BubbleIcon size={SMALL_BUBBLE_SIZE} {...props} />
);

const genBubbleFormatter = (
  {
    primaryColor = darkBlue,
    secondaryColor = white,
    textColor = black,
    small,
    bullet
  } = {}
) => ({ active, complete, index }) => (
  <BubbleIcon
    backgroundColor={complete || active ? primaryColor : secondaryColor}
    textColor={complete || active ? secondaryColor : textColor}
    borderColor={primaryColor}
    size={small ? SMALL_BUBBLE_SIZE : STANDARD_BUBBLE_SIZE}
    bullet={bullet === undefined ? index + 1 : bullet}
  />
);

export {
  BubbleIcon,
  SmallBubbleIcon,
  genBubbleFormatter,
  STANDARD_BUBBLE_SIZE,
  SMALL_BUBBLE_SIZE
};



// WEBPACK FOOTER //
// ./src/common/verticalSteps/bubbleIcons.js